const App = () => import('./App')
import router from './router'
import { store } from './store'

import { VueRegister } from './lib/register'
import { Apollo } from './lib/apollo'
import './lib/check-connection'
import i18n from './lib/i18n'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import config from './constants/config'
import filters from './constants/filters'
import FlagIcon from 'vue-flag-icon'
import LogRocket from 'logrocket'
import mixpanel from 'mixpanel-browser'
import { initPosthog } from './lib/posthog-client'

LogRocket.init(process.env.VUE_APP_LOGROCKET_ID)
mixpanel.init(process.env.VUE_APP_MIXPANEL_TOKEN)
initPosthog()

const Vue = VueRegister()
const apolloProvider = Apollo()
/* eslint-disable no-new */

filters(Vue)
config(Vue)

Vue.use(FlagIcon)
Vue.use(Vuetify)

new Vue({
  el: '#app',
  vuetify: new Vuetify({}),
  router,
  apolloProvider,
  i18n,
  store,
  template: '<App/>',
  components: { App },
  data: {
    config,
    filters
  },
  created () {
  }
})



// WEBPACK FOOTER //
// ./src/main.js